import { createContext, useState, useCallback } from 'react';

export const VideoContext = createContext();

const defaultVideo = {};

export const VideoProvider = ({ children }: { children: null | Node }) => {
  const [video, setVideo] = useState(defaultVideo);

  const clearVideo = useCallback(() => {
    setVideo(defaultVideo);
  }, []);

  const toggleVideoState = useCallback(
    () => {
      if (!video.url) return;

      setVideo({
        ...video,
        state: video.state === 'play' ? 'pause' : 'play'
      });
    },
    [video]
  );

  return (
    <VideoContext.Provider
      value={{ video, setVideo, clearVideo, toggleVideoState }}>
      {children}
    </VideoContext.Provider>
  );
};
